import { ReactNode } from 'react'
import styled from 'styled-components'
import { H, P, Wrapper } from '@farewill/ui'
import { COLOR, GTR } from '@farewill/ui/tokens'

const StyledSections = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${GTR.XL};
`

type Props = {
  id: string
  heading: string
  description: string
  children: ReactNode
}

const Part = ({ id, heading, description, children }: Props) => (
  // data-scroll-id is what lib/window/scroll's scrollToDataId jumps to
  <Wrapper
    as="section"
    id={id}
    data-scroll-id={id}
    aria-labelledby={`${id}-heading`}
  >
    <H size="M" id={`${id}-heading`}>
      {heading}
    </H>
    <P color={COLOR.GREY.DARK} margin={[GTR.XXS, 0, GTR.M]}>
      {description}
    </P>
    <StyledSections>{children}</StyledSections>
  </Wrapper>
)

export default Part
